// meeting/config/meeting-types/meeting-type-icons.ts
// -----------------------------------------------------------------------------
// INC 33 — set de íconos consistente para los Tipos de Reunión.
// Se persiste en el campo JSON `icon` (string, la clave `key`) y se renderiza
// como SVG (heroicons outline, viewBox 0 0 24 24) tanto en el selector del form
// como en la lista y demás lugares donde se visualiza un tipo de reunión.
// -----------------------------------------------------------------------------

export interface MeetingTypeIcon {
  /** Clave persistida en el campo `icon`. */
  key: string;
  /** Etiqueta legible (tooltip / accesibilidad). */
  label: string;
  /** Uno o más `d` de <path> (stroke outline). */
  paths: string[];
}

export const MEETING_TYPE_ICONS: MeetingTypeIcon[] = [
  {
    key: 'calendar',
    label: 'Calendario',
    paths: ['M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'],
  },
  {
    key: 'video',
    label: 'Videollamada',
    paths: ['M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z'],
  },
  {
    key: 'phone',
    label: 'Llamada',
    paths: ['M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'],
  },
  {
    key: 'users',
    label: 'Grupo',
    paths: ['M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-2.13a4 4 0 10-4-4 4 4 0 004 4z', 'M9 12a4 4 0 100-8 4 4 0 000 8z'],
  },
  {
    key: 'briefcase',
    label: 'Negocio',
    paths: ['M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'],
  },
  {
    key: 'chat',
    label: 'Conversación',
    paths: ['M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z'],
  },
  {
    key: 'presentation',
    label: 'Presentación',
    paths: ['M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'],
  },
  {
    key: 'clipboard',
    label: 'Seguimiento',
    paths: ['M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2'],
  },
  {
    key: 'academic',
    label: 'Capacitación',
    paths: ['M12 14l9-5-9-5-9 5 9 5z', 'M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z'],
  },
  {
    key: 'clock',
    label: 'Reloj',
    paths: ['M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'],
  },
  {
    key: 'map-pin',
    label: 'Presencial',
    paths: ['M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z', 'M15 11a3 3 0 11-6 0 3 3 0 016 0z'],
  },
  {
    key: 'document',
    label: 'Documento',
    paths: ['M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'],
  },
  {
    key: 'star',
    label: 'Destacada',
    paths: ['M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.196-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z'],
  },
  {
    key: 'bolt',
    label: 'Rápida',
    paths: ['M13 10V3L4 14h7v7l9-11h-7z'],
  },
];

const ICON_BY_KEY: Record<string, MeetingTypeIcon> = MEETING_TYPE_ICONS.reduce(
  (acc, icon) => {
    acc[icon.key] = icon;
    return acc;
  },
  {} as Record<string, MeetingTypeIcon>
);

/** Devuelve los paths SVG de una clave de ícono, o [] si no existe / está vacía. */
export function meetingTypeIconPaths(key?: string | null): string[] {
  if (!key) return [];
  return ICON_BY_KEY[key]?.paths ?? [];
}
